import React, { useState } from "react";
import "./HeroSection.css";
import illustrationImage from "../../../../assets/images/herosectionimg.png";
import BookDemoForm from "../../../../components/BookDemoForm/BookDemoForm";

const HeroSection = () => {
  const [showFormModal, setShowFormModal] = useState(false);

  const handleFormToggle = () => {
    setShowFormModal(!showFormModal);
  };

  return (
    <section className="bg-blue-50 py-16 px-6 md:px-12 lg:px-20">
      <div className="container mx-auto flex flex-col lg:flex-row items-center lg:justify-between">
        
        {/* Left Text Section */}
        <div className="text-center lg:text-left max-w-2xl lg:max-w-lg space-y-6">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-900">
            AI Automation to
          </h1>

          <p className="text-xl sm:text-2xl font-semibold text-black-700 leading-snug space-y-2">
            <span className="block">Scale Business</span>
            <span className="block">Save Time & Resources</span>
            <span className="block">Sales Efficiency & Engagement</span>
            <span className="block">24/7 Customer Support</span>
          </p>

          <p className="text-gray-700 text-lg">
            Managing operations, improving customer service, and staying competitive 
            while keeping costs under control can be overwhelming. Let AI automation 
            handle it for you!
          </p>

          {/* CTA Button */}
          <div className="flex justify-center lg:justify-start">
            <button
              className="px-6 py-3 bg-gradient-to-r from-blue-600 to-teal-400 text-white font-semibold rounded-full shadow-md hover:opacity-90 transition duration-300"
              onClick={handleFormToggle}
            >
              Book A Demo
            </button>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="flex justify-center mt-10 lg:mt-0 lg:w-1/2">
          <img
            src={illustrationImage}
            alt="AI Illustration"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg"
          />
        </div>
      </div>

      {/* Modal Form */}
      {showFormModal && <BookDemoForm onClose={handleFormToggle} />}
    </section>
  );
};

export default HeroSection;
